<template>
  <div class="row" style="margin-bottom: 10px">
    <document-element v-for="doc in sortedDocuments" :doc="doc" :class="rowClass"
      :key="doc.id"
      @deleteImage="$emit('deleteImage', $event)"
      @moveOutOfFolder="$emit('moveOutOfFolder', $event)"
      :show-drag="showDrag"
    />
  </div>
</template>

<script>
  export default {
    props: {
      documents: {
        required: true,
      },
      rowClass: {
        default: 'col-sm-4',
      },
      showDrag: {
        default: false,
      },
    },
    computed: {
      sortedDocuments () {
        return this.documents.sort((a, b)  => {
          if (a.created_at < b.created_at) {
            return 1
          }
          if (a.created_at > b.created_at) {
            return -1
          }
          return 0
        })
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/js/components/DocumentGallary.vue